import React, { useState, useEffect } from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import validate from "validate.js";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
  Button,
  IconButton,
  TextField,
  Link,
  Typography,
  Avatar,
  LinearProgress,
  CircularProgress,
  useMediaQuery,
} from "@material-ui/core";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import clsx from "clsx";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import SmsIcon from "@material-ui/icons/Sms";
import { RTL } from "components";
import { axios } from "./../../axios";
import {
  Loading,
  Set_Current_User,
  Set_Permission,
  Set_Role,
  Set_Token,
  showModalCondition,
  showSnackbar,
} from "redux/Action";
import { useDispatch, useSelector } from "react-redux";
import theme from "theme";
import { PatternFormat } from "react-number-format";
import Autocomplete from "@material-ui/lab/Autocomplete";

const schema = {
  email: {
    presence: { allowEmpty: false, message: "is required" },
    email: true,
    length: {
      maximum: 64,
    },
  },
  password: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 128,
    },
  },
};

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: "url(/images/222.png)",
    backgroundSize: "contain",
    backgroundRepeat: "repeat",
    // backgroundColor: theme.palette.background.default,
    height: "100%",
  },
  input: {
    marginTop: theme.spacing(2),
    width: "100%",
    fontFamily: "IranSans",
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: "100%",
  },
  grid: {
    height: "100%",
  },
  quoteContainer: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: "100%",
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: "url(/images/logoses.png)",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },

  content: {
    backgroundImage: "url(/images/222.png)",
    backgroundSize: "contain",
    backgroundRepeat: "repeat",
    height: "100%",
    display: "flex",
    width: "100%",
    // backgroundColor: "#F4F6F8",
    flexDirection: "column",
  },

  contentBody: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  },
  form: {
    width: "50%",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    padding: 25,
    borderRadius: 30,
    alignItems: "center",

    backgroundColor: "white",
    justifyContent: "center",
  },
  formSmall: {
    width: "85%",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    padding: 5,
    borderRadius: 30,
    alignItems: "center",

    backgroundColor: "white",
    justifyContent: "center",
  },
  formHeaders: {
    marginBottom: "14px",
    fontWeight: "bold",
  },
  title: {
    marginTop: theme.spacing(3),
  },
  titleCondition: {
    width: "100%",
    fontSize: 12,
    textAlign: "right",
  },
  titleError: {
    color: "red",
    width: "100%",
    textAlign: "right",
  },
  sugestion: {
    // marginTop: theme.spacing(2),
  },
  textField: {
    //  marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0),
  },
  avatar: {
    width: "auto",
    height: "auto",
  },
  wrapper: {
    position: "relative",
    width: "100%",
  },
  buttonProgress: {
    color: "#121E3E",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: -12,
  },
}));

const SignIn = (props) => {
  var persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ],
    arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ],
    fixNumbers = function(str) {
      if (typeof str === "string") {
        for (var i = 0; i < 10; i++) {
          str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
      }
      return str;
    };
  const dispatch = useDispatch();
  const isSmall = useMediaQuery(theme.breakpoints.down("xs"));

  const [Masked, setMasked] = React.useState({
    numberUser: "",
    codeUser: "",
  });
  const [error, setError] = React.useState({
    numberUser: "",
    codeUser: "",
  });
  const [numberUser, sendNumberUser] = React.useState("");
  const [codeUser, sendCodeUser] = React.useState("");

  const regex = /\D/g;

  const beforeMaskedValueChange = (newState, oldState, userInput) => {
    var { value } = fixNumbers(newState);
    var selection = newState.selection;
    var cursorPosition = selection ? selection.start : null;

    // keep minus if entered by user
    // if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
    //   if (cursorPosition === value.length) {
    //     cursorPosition--;
    //     selection = { start: cursorPosition, end: cursorPosition };
    //   }
    //   value = value.slice(0, -1);
    // }

    return {
      value,
      selection,
    };
  };
  const handleChangeMasked = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setError({ ...error, [name]: "" });
    let xx = fixNumbers(value.replace(regex, ""));
    if (name == "numberUser") {
      sendNumberUser(xx);
    } else if (name == "codeUser") {
      sendCodeUser(xx);
    }
    setMasked({
      ...Masked,
      [event.target.name]: fixNumbers(event.target.value),
    });
  };
  const isLoading = useSelector((state) => state.isLoading);

  const { history } = props;

  const classes = useStyles();

  const [values, setValues] = React.useState({
    showPassword: false,
  });

  const [Logined, setLogined] = React.useState(false);
  const [Reg, setReg] = React.useState(false);
  const [Allcities, setAllcities] = useState([]);
  const [Roles, setRoles] = React.useState([]);
  const [loadData, setLoadData] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [CityValue, setCityValue] = React.useState(null);
  const [RoleValue, setRoleValue] = React.useState(null);
  const [company_name, setCompany_Name] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [labelCompany, setLabelCompany] = React.useState("نام شرکت");

  const [full_name, setFull_name] = React.useState("");
  const [Err, setErr] = React.useState({
    full_name: "",
    company_name: "",
    city_id: "",
    role_id: "",
    address: "",
  });

  const [TokenUser, setTokenUser] = React.useState("");

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState((formState) => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {},
    }));
  }, [formState.values]);

  const handleBack = () => {
    history.goBack();
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSignIn = (event) => {
    event.preventDefault();
    history.push("/");
  };

  const [progress, setProgress] = React.useState(0);
  const [buffer, setBuffer] = React.useState(10);
  const [resend, SetResend] = React.useState(true);

  const [formData, setFormData] = useState({
    cell: "",
  });

  const progressRef = React.useRef(() => {});
  React.useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        SetResend(false);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  React.useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      sendBtn();
    }
  };

  const handleKeyDownVerify = (event) => {
    if (event.key === "Enter") {
      sendVerifyCodeBtn();
    }
  };

  const getDataReg = async (headers) => {
    // if (numberUser.length == 11) {
    try {
      const resRole = await axios.get("roles/can-create-shipment", {
        headers: headers,
      });
      setRoles(resRole.data.roles);

      const resCity = await axios.get("cities", {
        headers: headers,
      });
      let dataCity = resCity.data.cities;
      let final_City = [];
      dataCity.forEach((obj, i) => {
        final_City = [
          ...final_City,
          {
            id: obj.id,
            province_id: obj.province_id,
            county_id: obj.county_id,
            name: obj.name + " " + obj.get_province?.name,
          },
        ];
      });
      setAllcities(final_City);
      setLoadData(false);
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }
  };

  const Register = async (headers) => {
    // if (numberUser.length == 11) {

    try {
      dispatch(Loading());
      if (
        RoleValue != null &&
        CityValue != null &&
        full_name != "" &&
        company_name != ""
      ) {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TokenUser}`,
        };
        const res = await axios.patch(
          "auth/shipment-registering-user",
          {
            role_id: RoleValue,
            full_name: full_name,
            company_name: company_name,
            city_id: CityValue,
            address: address,
          },
          {
            headers,
          }
        );
        dispatch(showSnackbar(true, "success", res.data.message));

        const ress = await axios.get("auth/getCurrentUser", {
          headers: headers,
        });

        dispatch(Set_Current_User(res.data));
        localStorage.setItem("CurrentUser", JSON.stringify(res.data));
        let role_current = ress.data.roles[0] ? ress.data.roles[0].name : false;
        if (!role_current) {
          setLoadData(true);
          getDataReg(headers);
          setReg(true);
        } else {
          if (role_current != "Driver") {
            dispatch(Set_Role(ress.data.roles[0].name));
            localStorage.setItem("role", ress.data.roles[0].name);
            dispatch(showSnackbar(true, "success", "خوش آمدید"));
            let roless = ress.data.roles;
            let arr = [];
            let er = [];
            roless.forEach((element) => {
              er = [];
              er = element.permissions;

              er.forEach((e) => {
                arr.push(e.name);
              });
            });
            const uniqueSet = new Set(arr);
            const backToArray = [...uniqueSet];
            dispatch(Set_Token(TokenUser));
            localStorage.setItem("Token", TokenUser);
            dispatch(Set_Permission(backToArray));
            localStorage.setItem("Permission", JSON.stringify(backToArray));

            dispatch(Loading());
            history.push(
              ress.data.is_verified === 0 || ress.data.is_verified === 3
                ? "/auth"
                : "/add-shipment"
            );
          } else {
            dispatch(
              showSnackbar(true, "error", "شما دسترسی به این بخش ندارید")
            );
            setLogined(false);
            sendNumberUser(Masked.numberUser);

            dispatch(Loading());
          }
        }
      } else {
        dispatch(Loading());

        dispatch(
          showSnackbar(true, "error", "لطفا تمامی فیلدها را تکمیل نمایید")
        );
      }
    } catch (e) {
      dispatch(Loading());
      if (e.response.status === 422) {
        const er = e.response.data.errors;
        let er_keys = Object.keys(er);
        let errors = {
          full_name: "",
          company_name: "",
          address: "",
          city_id: "",
          role_id: "",
        };

        er_keys.forEach((element) => {
          errors[element] = er[element]["0"];
        });
        setErr(errors);
      }
    }
  };

  const sendBtn = async () => {
    // if (numberUser.length == 11) {
    try {
      let number = fixNumbers(numberUser.replace(regex, ""));
      sendNumberUser(number);
      dispatch(Loading());

      const res = await axios.post("auth/getCode", {
        cell: number,
      });
      // alert(res.data.real_code)
      SetResend(true);
      setLogined(true);
      setMasked({
        ...Masked,
        codeUser: "",
      });
      setProgress(10);
      setBuffer(10);
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      if (e.response.status === 422)
        setError({ ...error, numberUser: e.response.data.errors.cell });
    }

    // } elses {
    //   setError({...error, numberUser: 'ارقام شماره تماس صحیح نمی باشد'});
    // }
    //alert(res)
  };

  const ChangeRole = (v) => {
    setCompany_Name("");
    setRoleValue(v.id);
    if (v.alias_title == "شرکت های حمل و نقل") {
      setLabelCompany("نام شرکت حمل و نقل");
    } else if (v.alias_title == "بازرگانی ها") {
      setLabelCompany("نام بازرگانی");
    } else if (v.alias_title == "صاحبین بار و کالا") {
      setLabelCompany("نام کسب و کار");
    } else if (v.alias_title == "کارخانجات و مشاغل ایران") {
      setLabelCompany("نام کارخانه");
    } else {
      setLabelCompany("");
      setCompany_Name("متفرقه");
    }
  };

  function userExists(arr, name) {
    return arr.some(function(el) {
      return el.name === name;
    });
  }
  const sendVerifyCodeBtn = async () => {
    if (codeUser.length == 5) {
      try {
        dispatch(Loading());

        const res = await axios.post("auth/checkCode", {
          cell: numberUser,
          code: codeUser,
          user_can_submit_shipment: 1,
        });
        const token = await res.data.token;
        setTokenUser(token);
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };

        const ress = await axios.get("auth/getCurrentUser", {
          headers: headers,
        });

        dispatch(Set_Current_User(res.data));
        localStorage.setItem("CurrentUser", JSON.stringify(res.data));
        let role_current = ress.data.roles[0] ? ress.data.roles : false;
        if (!role_current) {
          setLoadData(true);
          getDataReg(headers);
          setReg(true);
        } else {
          if (!userExists(role_current, "Driver")) {
            dispatch(Set_Role(ress.data.roles[0].name));
            localStorage.setItem("role", ress.data.roles[0].name);
            dispatch(showSnackbar(true, "success", "خوش آمدید"));
            let roless = ress.data.roles;
            let arr = [];
            let er = [];
            roless.forEach((element) => {
              er = [];
              er = element.permissions;

              er.forEach((e) => {
                arr.push(e.name);
              });
            });
            const uniqueSet = new Set(arr);
            const backToArray = [...uniqueSet];
            dispatch(Set_Token(token));
            localStorage.setItem("Token", token);
            dispatch(Set_Permission(backToArray));
            localStorage.setItem("Permission", JSON.stringify(backToArray));

            dispatch(Loading());
            history.push("/add-shipment");
          } else {
            dispatch(
              showSnackbar(true, "error", "شما دسترسی به این بخش ندارید")
            );
            setLogined(false);
            sendNumberUser(Masked.numberUser);

            dispatch(Loading());
          }
        }
      } catch (e) {
        dispatch(Loading());

        // alert(e + 'eeeeeeeee');
        //   if (e.response.status === 404)
        //       setError({ ...error, codeUser: e.response.data.message});
        // }
      }
    } else {
      setError({ ...error, codeUser: "ارقام کد ارسالی صحیح نمی باشد" });
    }
    //alert(res)
  };

  return (
    <RTL>
      <div className={classes.root}>
        <Grid className={classes.grid} container>
          <Grid className={classes.content} item lg={7} xs={12}>
            <div className={classes.content}>
              <div className={classes.contentBody}>
                <form
                  className={isSmall ? classes.formSmall : classes.form}
                  onSubmit={handleSignIn}
                >
                  {!Reg ? (
                    <Avatar
                      style={{ borderRadius: 0 }}
                      alt="Person"
                      className={classes.avatar}
                      component={RouterLink}
                      src={"/images/lock.png"}
                    />
                  ) : (
                    <></>
                  )}
                  {Reg ? (
                    loadData ? (
                      <CircularProgress size={24} color="#121E3E" />
                    ) : (
                      <>
                        <Autocomplete
                          noOptionsText="همچنین شغلی وجود ندارد"
                          options={Roles}
                          style={{ width: "100%" }}
                          getOptionLabel={(option) => option.alias_title || ""}
                          onChange={(e, v) =>
                            v != null
                              ? ChangeRole(v)
                              : ` ${setRoleValue(null)} ${setLabelCompany(
                                  "نام شرکت"
                                )}${setCompany_Name("")}`
                          }
                          renderInput={(params) => (
                            <TextField
                              className={classes.input}
                              {...params}
                              label="عنوان شغل"
                              variant="outlined"
                              error={Boolean(Err.role_id)}
                              helperText={Err.role_id}
                            />
                          )}
                        />

                        <TextField
                          style={
                            labelCompany == ""
                              ? { display: "none" }
                              : { display: "flex" }
                          }
                          className={classes.input}
                          label={labelCompany}
                          error={Boolean(Err.company_name)}
                          helperText={Err.company_name}
                          variant="outlined"
                          value={company_name}
                          onChange={(e) => {
                            setErr({
                              ...Err,
                              company_name: "",
                            });
                            setCompany_Name(e.target.value);
                          }}
                        />

                        <Autocomplete
                          noOptionsText="همچنین شهری وجود ندارد"
                          options={Allcities}
                          style={{ width: "100%" }}
                          getOptionLabel={(option) => option.name || ""}
                          onChange={(e, v) =>
                            v != null ? setCityValue(v.id) : setCityValue(null)
                          }
                          renderInput={(params) => (
                            <TextField
                              className={classes.input}
                              {...params}
                              label="شهر "
                              error={Boolean(Err.city_id)}
                              helperText={Err.city_id}
                              variant="outlined"
                            />
                          )}
                        />
                        <TextField
                          className={classes.input}
                          label="نام و نام خانوادگی"
                          error={Boolean(Err.full_name)}
                          helperText={Err.full_name}
                          variant="outlined"
                          value={full_name}
                          onChange={(e) => {
                            setErr({
                              ...Err,
                              full_name: "",
                            });
                            setFull_name(e.target.value);
                          }}
                        />
                        <TextField
                          multiline
                          className={classes.input}
                          label="آدرس"
                          fullWidth
                          rows="2"
                          error={Boolean(Err.address)}
                          helperText={Err.address}
                          variant="outlined"
                          value={address}
                          onChange={(e) => {
                            setErr({
                              ...Err,
                              address: "",
                            });
                            setAddress(e.target.value);
                          }}
                          name="address"
                        />
                      </>
                    )
                  ) : Logined ? (
                    <>
                      <InputLabel
                        style={{ width: "100%", textAlign: "right" }}
                        htmlFor="formatted-text-mask-input"
                      >
                        کد دریافتی
                      </InputLabel>

                      <PatternFormat
                        style={{
                          direction: "ltr",
                          borderWidth: 1,
                          padding: 15,
                          width: "100%",
                          textAlign: "center",
                          flex: 1,
                          borderRadius: 10,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        className={classes.input}
                        format="# # # # #"
                        value={Masked.codeUser}
                        onKeyUp={(e) => handleChangeMasked(e)}
                        name="codeUser"
                        onKeyDown={handleKeyDownVerify}
                        mask="_"
                      />
                      {error.codeUser != "" ? (
                        <Typography className={classes.titleError}>
                          {error.codeUser}
                        </Typography>
                      ) : (
                        ""
                      )}
                      {resend ? (
                        <>
                          <LinearProgress
                            style={{ width: "100%", direction: "ltr" }}
                            variant="buffer"
                            value={progress}
                            valueBuffer={buffer}
                          />
                          <Button
                            onClick={() => {
                              setLogined(false);
                              sendNumberUser(Masked.numberUser);
                            }}
                            size="small"
                            style={{ fontSize: 10 }}
                          >
                            ویرایش شماره تماس
                          </Button>
                        </>
                      ) : (
                        <Grid
                          container
                          justify="space-between"
                          style={{ flex: 1, justifyContent: "space" }}
                        >
                          <Button
                            onClick={() => {
                              setLogined(false);
                              sendNumberUser(Masked.numberUser);
                            }}
                            size="small"
                            style={{ fontSize: 10 }}
                          >
                            ویرایش شماره تماس
                          </Button>
                          <Button
                            onClick={() => {
                              sendBtn();
                            }}
                            size="small"
                            style={{ fontSize: 10 }}
                          >
                            ارسال مجدد کد فعالسازی
                          </Button>
                        </Grid>
                      )}
                    </>
                  ) : (
                    <>
                      <InputLabel
                        style={{ width: "100%", textAlign: "right" }}
                        htmlFor="formatted-text-mask-input"
                      >
                        شماره تماس
                      </InputLabel>

                      <PatternFormat
                        style={{
                          direction: "ltr",
                          borderWidth: 1,
                          padding: 15,
                          width: "100%",
                          textAlign: "center",
                          flex: 1,
                          borderRadius: 10,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        className={classes.input}
                        format="#### ### ## ##"
                        onKeyUp={(e) => handleChangeMasked(e)}
                        name="numberUser"
                        onKeyDown={handleKeyDown}
                        value={Masked.numberUser}
                        mask="_"
                      />
                      <Typography className={classes.titleCondition}>
                        ثبت نام شما به منزله تایید
                        <Button
                          style={{ backgroundColor: "white" }}
                          variant="text"
                          color="secondary"
                          onClick={() => dispatch(showModalCondition(true))}
                          size="small"
                        >
                          حریم خصوصی
                        </Button>
                        آنلاین بار است
                      </Typography>
                      {error.numberUser != "" ? (
                        <Typography className={classes.titleError}>
                          {error.numberUser}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </>
                  )}

                  <FormControl
                    style={{ display: "none" }}
                    fullWidth
                    className={clsx(classes.input)}
                    variant="outlined"
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      کلمه عبور
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={values.showPassword ? "text" : "password"}
                      value={values.password}
                      onChange={handleChange("password")}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {values.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                    />
                  </FormControl>

                  {Reg ? (
                    loadData ? (
                      <CircularProgress
                        size={24}
                        color="#121E3E"
                        style={{ display: "none" }}
                      />
                    ) : (
                      <div className={classes.wrapper}>
                        <Button
                          fullWidth
                          className={classes.input}
                          variant="contained"
                          color="secondary"
                          size="large"
                          disabled={isLoading}
                          onClick={() => {
                            Register();
                          }}
                          // type="submit"
                          // href='/dashboard'
                          startIcon={
                            <SmsIcon className={classes.submitButtonIcon} />
                          }
                        >
                          ثبت نام
                        </Button>
                        {isLoading && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </div>
                    )
                  ) : !Logined ? (
                    <div className={classes.wrapper}>
                      <Button
                        fullWidth
                        className={(classes.input, classes.inputBtn)}
                        variant="contained"
                        color="secondary"
                        size="large"
                        disabled={isLoading}
                        onClick={() => {
                          sendBtn();
                        }}
                        // type="submit"
                        // href='/dashboard'
                        startIcon={
                          <SmsIcon className={classes.submitButtonIcon} />
                        }
                      >
                        ارسال پیامک
                      </Button>
                      {isLoading && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </div>
                  ) : (
                    <div className={classes.wrapper}>
                      <Button
                        fullWidth
                        className={(classes.input, classes.inputBtn)}
                        variant="contained"
                        color="secondary"
                        size="large"
                        disabled={isLoading}
                        //   type="submit"
                        // href='/dashboard'
                        onClick={() => sendVerifyCodeBtn()}
                        startIcon={
                          <LockOpenIcon className={classes.submitButtonIcon} />
                        }
                      >
                        ورود به حساب کاربری
                      </Button>
                      {isLoading && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </Grid>
          <Grid className={classes.quoteContainer} item lg={5}>
            <div className={classes.quote}></div>
          </Grid>
        </Grid>
      </div>
    </RTL>
  );
};

SignIn.propTypes = {
  history: PropTypes.object,
};

export default withRouter(SignIn);
